export default __webpack_public_path__ + "ca7ca8475b3b7dc634ba4ec70df7fa60.jpg";